import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=2b9baf52"
import script from "./listItem.vue?vue&type=script&lang=js"
export * from "./listItem.vue?vue&type=script&lang=js"
import style0 from "./listItem.vue?vue&type=style&index=0&id=2b9baf52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports